import React, { Component } from 'react'
import Img from 'gatsby-image'
import Modal from '../components/Fleet/FleetModal'
import axios from 'axios'
import Helmet from 'react-helmet'
import { backendURL } from '../data/config.json'

import EmailOffers from '../components/EmailOffers'

class DealsEs extends Component {
  constructor(props) {
    super(props)
    this.state = {}
    this.renderItems = this.renderItems.bind(this)
  }
  componentDidMount() {
    axios.get(`${backendURL}/api/deals`).then(res => {
      const deals = res.data
      this.setState({ deals })
    })
  }
  renderItems() {
    return _.map(this.state.deals, (deal, i) => {
      const { code, image, title, description, published } = deal  
      if (published) {
        return (
          <div key={i} className="item">
            <div className="image">
              <img
                src={`${backendURL}${image}`}
                alt={title}
              />
            </div>
            <div className="deal-content">
              <h2>{title.es}</h2>
              <div className="excerpt">{description.es}</div>
              <div className="reserve">
                <Modal btn="Reserve" couponCode={code} lang={this.props.pathContext.langKey}/>
              </div>
            </div>
          </div>
        )
      }
      else if(!published){
        return (
          <div>       
              <h1>"Próximamente"</h1>
          </div>
        )
      }
      return null
    })
  }
  render() {
    const { langKey: lang } = this.props.pathContext
    const { edges: items } = this.props.data.allEmailOffersJson
    return (
      <div className="page deals">
            <Helmet
            title={`Ofertas de Budget | Budget`}
            meta={[
              {
                name: 'description',
                content:
                  'Preguntas frecuentes sobre el alquiler de autos. Contáctenos: SJO: +506 2436-2070 / LIR: +506 2436-2071.',
              },
            ]}
            link={[
              {
                rel: 'alternate',
                hreflang: 'es',
                href:
                  './en/deals',
              },
            ]}
          />
        <div className="excerpt">
          <Img sizes={this.props.data.imageSharp.sizes} />
          <div className="content-wrapper">
            <h1>Ofertas de Budget</h1>
            <div className="grid-wrapper">
            <div className="item">
                <EmailOffers
                  lang={lang}
                  items={items}
                  type="EmailOffers"
                  title="Email Offers"
                />
              </div>
            {this.renderItems()}</div>
          </div>
        </div>
      </div>
    )
  }
}

export const query = graphql`

 query EmailOffersEs {
  imageSharp(id: { regex: "/deals-top-background/" }) {
    sizes(maxWidth: 1600) {
      ...GatsbyImageSharpSizes
    }
  }
    allEmailOffersJson {
      edges {
        node {
          title {
            en
            es
          }
          description {
            en
            es
          }
          button {
            en
            es
          }
          inputPlaceholder {
            en
            es
          }
          fieldname
        }
      }
    }
  }
`
export default DealsEs



// WEBPACK FOOTER //
// ./src/pages/deals.es.js